import { connect } from 'react-redux'
import { replace } from 'react-router-redux'
import at from 'lodash/at'
import get from 'lodash/get'
import moment from 'moment'

import ServicingSummary from '../../components/servicings/servicing-summary'

import { approveServicing, denyServicing, rescheduleServicing, markServicingAsOpen } from '../../actions/servicings'
import { fetchWorkOrder } from '../../actions/work-orders'

function mapStateToProps (state, ownProps) {
  const servicing = state.servicings[ownProps.servicingId]
  const { autoApprovable, showInputted } = get(state.workOrders, `${ownProps.workOrderId}`, {})
  const services = at(state.services, servicing.services).map(s => ({
    ...s,
    completedAt: servicing.servicesServicings[s.id].completedAt ?
      moment(servicing.servicesServicings[s.id].completedAt) : null
  }))
  const area = state.areas[servicing.area]
  const completedBy = state.users[servicing.completedBy]
  const inputtedBy = state.users[servicing.createdBy]
  const deletedBy = state.users[servicing.deletedBy]
  const pinnedComment = state.comments[area.pinnedComment]
  const canShowInputted = get(state.locations, `${servicing.location}.showInputtedWorkOrders`, false) && showInputted

  return {
    servicing,
    services,
    area,
    completedBy,
    pinnedComment,
    autoApprovable,
    inputtedBy,
    deletedBy,
    canShowInputted
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  const id = ownProps.servicingId

  function reloadWorkOrder () {
    return dispatch(fetchWorkOrder(ownProps.workOrderId))
  }

  return {
    onApprove () {
      dispatch(approveServicing(id))
        .then(() => reloadWorkOrder())
    },

    onRequireApproval () {
      dispatch(replace(`summaries/${ownProps.workOrderId}/confirm/${id}`))
    },

    onDeny () {
      dispatch(denyServicing(id))
        .then(() => reloadWorkOrder())
    },

    onReschedule () {
      dispatch(rescheduleServicing(id))
        .then(() => reloadWorkOrder())
    },

    onMarkAsOpen () {
      dispatch(markServicingAsOpen(id))
        .then(() => reloadWorkOrder())
    },

    requireOpenRedoReason (canAddServices = false) {
      dispatch(replace(`summaries/${ownProps.workOrderId}/open_redo_reason/${id}?canAddServices=${canAddServices}`))
    },

    requireRescheduledRedoReason (canAddServices = false) {
      dispatch(replace(`summaries/${ownProps.workOrderId}/rescheduled_redo_reason/${id}?canAddServices=${canAddServices}`))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ServicingSummary)



// WEBPACK FOOTER //
// ./src/containers/servicings/servicing-summary-container.js